import React, { useMemo, useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "../actions/Actions.js";
import StyleSliderItem from "../components/StyleSliderItem.js";
import StyleModal from "../components/StyleModal.js";
import Modal from "react-bootstrap/Modal";

import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import { useIsMount } from "../hooks/useIsMount";
import produce from "immer";
import { Helmet } from "react-helmet";
import { useLoaderData } from "react-router-dom";

const options = [
  { text: "Last 7 Days", value: "7days" },
  { text: "Last 30 Days", value: "30days" },
  { text: "This Year", value: "ThisYear" },
  { text: "Last Year", value: "LastYear" },
  { text: "All Time", value: "AllTime" },
];

const loadStyles = (option) => {
  return fetch(
    __server__ + "/API/pub/popular_styles?limit=100&option=" + option,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((data) => data);
};

function Popular(props) {
  const [showModal, setShowModal] = useState(false);
  const [activeStyleId, setActiveStyleId] = useState(null);
  const loadedData = useLoaderData();

  const [styles, setStyles] = useState(loadedData);
  const [optionIndex, setOptionIndex] = useState(1);
  const [fetchingStatus, setFetchingStatus] = useState(
    styles?.length > 0 ? "HYDRATED" : "FETCHING"
  );
  const isMount = useIsMount();

  const onLikeCounterChange = (style_id, change) => {
    let newStyles = produce(styles, (draftStyles) => {
      let tempStyle = draftStyles.filter(
        (style) => style.style_id === style_id
      )[0];
      tempStyle.likes = Number(tempStyle.likes) + change;
      draftStyles.sort((a, b) => Number(b.likes) - Number(a.likes));
    });
    setStyles(newStyles);
  };

  const activeStyle = useMemo(() => {
    return styles.filter((style) => style.style_id === activeStyleId)[0];
  }, [activeStyleId, styles]);

  const loadData = () => {
    setFetchingStatus("FETCHING");
    loadStyles(options[optionIndex].value).then((data) => {
      setStyles(data);
      setFetchingStatus("LOADED");
    });
  };

  useEffect(() => {
    if (!(isMount && fetchingStatus === "HYDRATED")) {
      loadData();
    }
  }, [optionIndex]);

  return (
    <div>
      <Helmet>
        <meta
          property="og:title"
          content="The Hottest Basketball Shoes Styles"
        />
        <meta property="og:image:width" content="1020" />
        <meta property="og:image:height" content="510" />
        <meta
          property="og:image"
          content="https://www.thehoopsgeek.com/wp-content/uploads/2018/07/10_best_basketball_shoes-2.png"
        />
        <meta
          name="description"
          content="Find basketball shoes that fit your playing style, feet, and budget by answering 6 simple questions."
        />
        <title>The Most Popular Basketball Shoes</title>
      </Helmet>

      <div id="like_container" style={{ minHeight: "100vh" }}>
        <Modal
          dialogClassName="thg_style_modal"
          onHide={() => {
            setShowModal(false);
          }}
          show={showModal}
        >
          <StyleModal
            onLikeCounterChange={onLikeCounterChange}
            linkId="popular"
            fetchData
            hideModal={() => {
              setShowModal(false);
            }}
            activeStyle={activeStyle}
          />
        </Modal>
        <div
          css={{
            "@media (min-width:576px)": {
              display: "flex",
              alignItems: "center",
            },
            marginBottom: 30,
          }}
        >
          <h1 style={{ flex: 1 }} className="thg_h3_size thg_header">
            Most Popular Basketball Shoes
          </h1>
          <Form.Control
            style={{ maxWidth: 200 }}
            onChange={(e) => {
              setStyles([]);
              setOptionIndex(e.target.value);
            }}
            value={optionIndex}
            as="select"
          >
            {options.map((option, index) => (
              <option key={index} value={index}>
                {option.text}
              </option>
            ))}
          </Form.Control>
        </div>
        {fetchingStatus === "FETCHING" && (
          <div style={{ textAlign: "center", paddingTop: 100 }}>
            <Spinner animation="border" variant="primary" />
            <div>Loading Shoes</div>
          </div>
        )}
        <Row style={{ marginTop: 10, margin: "0px -5px 150px -5px" }}>
          {styles.map((style) => (
            <Col
              lg={2}
              md={3}
              sm={4}
              xs={6}
              key={style.style_id}
              style={{ marginBottom: 50, padding: 5 }}
            >
              <StyleSliderItem
                onClick={() => {
                  setShowModal(true);
                  setActiveStyleId(style.style_id);
                }}
                textContainerStyle={{ padding: "5px 20px 10px 5px" }}
                key={style.style_id}
                styleItem={style}
                shoeName={style.shoe_name}
                showShoeName
                showPrice={false}
                showLikeButton={false}
                showLikes
                imageProps={{ padding: "10% 8%" }}
                responsive
              />
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}

export default connect(
  (state) => ({
    likes: state.persistData.likes,
    data: state.data.data,
  }),
  (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch),
  })
)(Popular);
